import VehiclesView from "./view";
import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "@/redux/reducers/Models";
import { useEffect, useState } from "react";
import { authorize, setUser } from "@/redux/ducks/user";
import { useLocation, useNavigate } from "react-router-dom";
import { PropsView } from "./Models";

export default function Vehicles() {
  const navigate = useNavigate();
  const TIMEOUT = 500;

  const dispatch = useDispatch();
  const user = useSelector((state: ReducersTypes) => state.userReducer);

  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [plate, setPlate] = useState<string>(user?.plate as string ?? "");
  const [isVerified] = useState(true);

  const toggleModal = () => setIsVisibleModal(isVisibleModal => !isVisibleModal);

  const goBack = () => navigate(-1);

  const getIsDisabled = () => {
    return isLoading || plate?.length < 8 || plate?.toLowerCase() === String(user?.plate ?? "")?.toLowerCase() || !isVerified;
  }

  const handleKeyDown: PropsView['handleKeyDown'] = (event) => {
    if (event.key === 'Enter') {
      change();
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    setPlate(value);
  }

  const handleAuthorize = (success: boolean, errorMessage?: string) => {
    setIsLoading(false);

    if (!success) {
      if (errorMessage === "timeout") setError(true);
      toggleModal();
      return;
    }

    dispatch(
      setUser({
        plate,
        requestId: undefined,
        debts: undefined,
        cart: undefined,
      })
    );

    setTimeout(() => {
      goBack();
    }, TIMEOUT);
  }

  const change = (e?: React.ChangeEvent<HTMLFormElement>) => {
    
    e?.preventDefault();
    
    if (getIsDisabled()) return;

    setIsLoading(true);    
    
    const authPayload: any = {
      plate,
      token: '',
      callback: handleAuthorize,
    };

    dispatch(authorize(authPayload));
  }

  return (
    <VehiclesView
      goBack={goBack}
      change={change}
      plate={plate}
      onChange={onChange}
      isLoading={isLoading}
      isVisibleModal={isVisibleModal}
      error={error}
      toggleModal={toggleModal}
      handleKeyDown={handleKeyDown}
      isDisabled={getIsDisabled()}
    />
  );
}